import { render, staticRenderFns } from "./MeasurementPage.vue?vue&type=template&id=1b37151c&scoped=true&"
import script from "./MeasurementPage.vue?vue&type=script&lang=js&"
export * from "./MeasurementPage.vue?vue&type=script&lang=js&"
import style0 from "./MeasurementPage.vue?vue&type=style&index=0&id=1b37151c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b37151c",
  null
  
)

export default component.exports